import { render, staticRenderFns } from "./PestanasEstado.vue?vue&type=template&id=6315c43d&scoped=true"
import script from "./PestanasEstado.vue?vue&type=script&lang=js"
export * from "./PestanasEstado.vue?vue&type=script&lang=js"
import style0 from "./PestanasEstado.vue?vue&type=style&index=0&id=6315c43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315c43d",
  null
  
)

export default component.exports